import { useNavigate } from "react-router-dom";
import RegionCard from "./RegionCard";
import { Container, Row } from "react-bootstrap";

const RegionList = ({ regions, isLoading }) => {

  const navigate = useNavigate();
  const handleRegionClick = async (region) => {
    navigate("region_wise_plans", { state: { region } });
  };

  return (
    <Container>
      <br />
      {isLoading ? (
        <p>Loading.....</p>
      ) : (
        <Row className='mt-4'>
          <>
            {regions.map((region, index) => (

              <RegionCard
                key={index}
                region_slug={region.region_slug}
                region_name={region.region_name}
                flag_image={region.flag_image}
                isLoading={isLoading}
                onClick={() => handleRegionClick(region)}
              />
            ))}
          </>
          {/* )} */}
        </Row>
      )}
    </Container>
  );
};

export default RegionList;